import {ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {LoadingWheelService} from "./loading-wheel.service";
import {Subscription} from "rxjs/Subscription";

@Component({
    selector: 'loading-wheel',
    providers: [],
    templateUrl: './loading-wheel.component.html'
})
export class LoadingWheelComponent implements OnDestroy {

    subscription: Subscription;

    constructor(private loadingWheelService: LoadingWheelService,
                private changeDetector: ChangeDetectorRef) {
        this.subscription = this.loadingWheelService.loadingSubject.subscribe(() => this.changeDetector.detectChanges());
    }

    showLoadingWheel() {
        return this.loadingWheelService.isLoading();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/loading/loading-wheel.component.ts